import React, { useState } from "react";
import { useDispatch } from "react-redux";
import SlidePanel from "../shared/SlidePanel";
import toast from "../shared/Toast";
import { marketingAction } from "../../_actions/marketing.actions";
import { ChannelCards, getSmsText, BOOKING_PREVIEW } from "./MarketingEditorParts";

function BookingUpdatePanel({ data, salonId, onClose, onSaved }) {
  const dispatch = useDispatch();
  const [reminder, setReminder] = useState({ ...data });
  const [saving, setSaving] = useState(false);
  const map = BOOKING_PREVIEW[data?.type] || BOOKING_PREVIEW[1];

  const setStatus = (field, checked) =>
    setReminder((r) => ({ ...r, [field]: checked ? 1 : 0 }));

  const save = () => {
    const payload = { reminders: [reminder], type: 3, salonId };
    setSaving(true);
    dispatch(marketingAction.updateSetting(payload))
      .then((res) => {
        setSaving(false);
        if (res?.data?.statusCode === 1) {
          toast.success(res?.data?.responseData?.message);
          if (onSaved) onSaved();
        }
      })
      .catch(() => setSaving(false));
  };

  const footer = (
    <>
      <button type="button" className="sp-btn-secondary" onClick={onClose}>
        Cancel
      </button>
      <button type="button" className="sp-btn-primary" onClick={save} disabled={saving}>
        Save
      </button>
    </>
  );

  return (
    <SlidePanel title={data?.title} onClose={onClose} footer={footer} width={520}>
      <p className="sp-hint" style={{ marginTop: 0 }}>
        {data?.note}
      </p>
      <ChannelCards
        smsDesc={
          <>
            SMS messages are sent to <b>all clients</b> to the phone number you have
            saved on client record.
          </>
        }
        emailDesc={
          <>
            Emails are sent to <b>all clients</b> to the email address you have saved on
            their client record.
          </>
        }
        statusSMS={reminder?.statusSMSreminder}
        statusEmail={reminder?.statusEmailReminder}
        onToggleSms={(c) => setStatus("statusSMSreminder", c)}
        onToggleEmail={(c) => setStatus("statusEmailReminder", c)}
        smsText={getSmsText(map.sms)}
        emailType={map.email}
      />
    </SlidePanel>
  );
}

export default BookingUpdatePanel;
